(function($){
$(function() {
	var secondImageOnHover = {
		init: function(){
			var self = this;

			self.thumbnailImages = $('.product-thumbnail-image'),
			self.touchEnabled = false;		

			self.setUpEventHandlers();
		},
		setUpEventHandlers: function(){
			var self = this;

			// turn off second image on hover if touch is available
			$(document).on("touchstart", function(e){
				if(!self.touchEnabled){
					self.disableSwapOnHover();
				}
			});

			self.enableSwapOnHover();
		},
		enableSwapOnHover: function(){
			var self = this;
			// show the second image on hover
			self.thumbnailImages.on('mouseover', function() {
				var $this = $(this),
					image2 = $this.find('.image2');

				if( image2.length > 0 ){
					$this.find('.image1').hide();
					image2.show();
				}
			});
			self.thumbnailImages.on('mouseout', function() {
				var $this = $(this),
					image2 = $this.find('.image2');

				if( image2.length > 0 ){
					$this.find('.image1').show();
					image2.hide();
				}
			});
		},
		disableSwapOnHover: function(){
			var self = this;
			self.touchEnabled = true;
			self.thumbnailImages.off();
		}
	}

	secondImageOnHover.init();

});
})(jQuery);